import React, { useState } from "react";
import "./index.scss";
import pdfImg from "../../assets/images/pdf.png";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { imageUrlOthers } from "../../services/CommonUrl";
import { Link } from "react-router-dom";
import { getIconForDaysType } from "../icon-days-type";

const ThumbnailLightbox = ({ thumbnails, data }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    const imagesArr = thumbnails;
    const imagesList = typeof imagesArr === "string" ? [imagesArr] : imagesArr || [];
    const isPDF = (file) => /\.pdf$/i.test(file);

    const handleOpenLightbox = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    }
    // console.log("ThumbnailLightbox==>", thumbnails)

    return (
        <>
            {imagesArr?.length === 0 ? (
                <div className="civ-item-img">
                    <img
                        src={getIconForDaysType(
                            data?.days_type,
                            data?.types[0]
                        )}
                        alt={"No Picture Available"}
                    />
                </div>
            ) : (
                <>
                    <div className='civ-item-img cursor-pointer' onClick={() => handleOpenLightbox(0)}>
                        <img
                            src={isPDF(imagesArr[0]) ? pdfImg : imageUrlOthers + imagesArr[0]}
                            alt={data?.days_type || "No Picture Available"}
                        />
                        {imagesArr?.length > 1 && (
                            <div className="civ-item-img-count" onClick={() => handleOpenLightbox(0)}>
                                <span>+{Number(imagesArr?.length) - 1}</span>
                            </div>
                        )}
                    </div>
                    {isOpen && (
                        <Lightbox
                            mainSrc={isPDF(imagesList[photoIndex]) ? pdfImg : imageUrlOthers + imagesList[photoIndex]}
                            nextSrc={
                                photoIndex < imagesList.length - 1 ?
                                    isPDF(imagesList[(photoIndex + 1) % imagesList.length])
                                        ? pdfImg
                                        : imageUrlOthers + imagesList[(photoIndex + 1) % imagesList.length]
                                    : null
                            }
                            prevSrc={
                                photoIndex > 0 ?
                                    isPDF(imagesList[(photoIndex + imagesList.length - 1) % imagesList.length])
                                        ? pdfImg
                                        : imageUrlOthers + imagesList[(photoIndex + imagesList.length - 1) % imagesList.length]
                                    : null
                            }
                            onCloseRequest={() => setIsOpen(false)}
                            onMovePrevRequest={() =>
                                setPhotoIndex((photoIndex + imagesList.length - 1) % imagesList.length)
                            }
                            onMoveNextRequest={() =>
                                setPhotoIndex((photoIndex + 1) % imagesList.length)
                            }
                            toolbarButtons={
                                isPDF(imagesList[photoIndex])
                                    ? [
                                        <Link
                                            to="#"
                                            onClick={() => window.open(imageUrlOthers + imagesList[photoIndex], "_blank", "noopener,noreferrer")}
                                            className="btn btn-primary-color border-radius-10 download-button"
                                        >
                                            PDF View
                                        </Link>
                                    ]
                                    : []
                            }
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ThumbnailLightbox;
